import { Controller } from "@hotwired/stimulus"

// Reusable utility controller. Reloads the current page with the
// element's `name` attribute as a URL parameter when its value
// changes — useful for "pick a parent dropdown, repopulate the
// child dropdown server-side" patterns.
//
// Example wiring:
//
//   <select name="warehouse_id"
//           data-controller="reload-on-change"
//           data-action="change->reload-on-change#change">
//     ...
//   </select>
//
// On change, navigates to the same URL with `?warehouse_id=X` (or
// strips it if the user cleared the select). The server can then
// render dependent dropdowns based on params[:warehouse_id] without
// any custom XHR / Turbo Frame wiring.
//
// Other parent-of-dropdown selects (location > bin, category >
// subcategory, etc.) can opt in with no controller changes — just
// drop in the same data-controller / data-action.
export default class extends Controller {
    change(event) {
        const url = new URL(window.location.href)
        const key = event.target.name
        const val = event.target.value

        if (!key) return

        if (val && val.length > 0) {
            url.searchParams.set(key, val)
        } else {
            url.searchParams.delete(key)
        }
        window.location.href = url.toString()
    }
}
